/**
 * Root Imports
*/

import { ApiRequest } from '~/util/Api';

/**
 * Locals
*/

const endpoint = '/api/v1/roles';

/**
 * Exports
*/

/**
 * 
 */
export function IndexRoleService() {
  const config = {
    method: 'GET',
    uri: endpoint
  };

  return ApiRequest(config);
}

/**
 * 
 */
export function ShowRoleService({ id }) {
  const config = {
    method: 'GET',
    uri: `${ endpoint }/${ id }`
  };

  return ApiRequest(config);
}